import { PaymentMethodT } from './constants';

/** ***********************************
 *************************************
 **** Contract Input Validators ******
 *************************************
 ************************************ */

export const isCnuDrawInputValid = (value: string, min: number, max: number): boolean => {
  const amount = Number(value);

  if (value.trim() === '' || Number.isNaN(amount)) return false;

  return amount === 0 || (amount >= min && amount <= max);
};

export const isPaymentMethodValid = (method: PaymentMethodT | null): boolean => method !== null;

// `undefined` covers the offer not having loaded yet; `null` covers nothing selected yet.
// Neither is a mismatch — there's nothing to compare against, or nothing to compare.
export const isRepaymentMethodMismatched = (
  selected: PaymentMethodT | null,
  offerRepaymentMethod: string | undefined,
): boolean => selected !== null && offerRepaymentMethod !== undefined && selected !== offerRepaymentMethod;
